import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const AsyncEditBaseCustomView = Loadable({
  loader: () => import( /* webpackChunkName: "edit-custom-view" */'find-and-filter-components/custom-views-build/public/EditBaseCustomViewWizard'),
  // don't render a loading spinner for this because it's a UIModalPanel
  LoadingComponent: () => null
});
export default AsyncEditBaseCustomView;